import { Component, ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
  renderError?(error: Error): ReactNode;
}

interface ErrorBoundaryState {
  error: Error | undefined;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = {
    error: undefined,
  };

  componentDidCatch(error: Error) {
    this.setState({ error });
  }

  render() {
    if (this.state.error) {
      if (this.props.renderError && this.state.error) {
        return this.props.renderError(this.state.error);
      }

      return <></>;
    }

    return this.props.children;
  }
}
